import type { Task } from "@app/core";
import type { LabelMatchMode } from "../stores/labelFilter.store.js";

/**
 * Filter tasks by the selected label ids. Empty selection = no filter (all
 * tasks pass). "any" keeps tasks carrying at least one selected label; "all"
 * keeps only tasks carrying every selected label. Applied alongside
 * `visibleTasks` (calendar-visibility) at each view's call site.
 */
export function filterByLabels(
  tasks: Task[],
  selected: string[],
  mode: LabelMatchMode,
): Task[] {
  if (selected.length === 0) return tasks;
  const selectedSet = new Set(selected);
  return tasks.filter((t) => {
    return mode === "all"
      ? selected.every((s) => t.label_ids.includes(s))
      : t.label_ids.some((id) => selectedSet.has(id));
  });
}
